<template>
	<div class="ai_container">
		<Header :onPrev="handlePrev" :isShowHome="true" :returnName="'AiMain'"/>
		<div class="search_car_wrapper">
			<div class="top_wrapper">
				<h1 class="heading_3" style="whiteSpace: pre-line">{{ title }}</h1>
				<div ref="lottieContainer" v-show="isLoading" />
				<div v-if="!isLoading">
					<div v-if="isErrorCarNumber" class="f_gray_4 body_8" style="marginTop:8px">
						자동으로 차대번호를 조회할 수 없어요.<br />내 차 차대번호를 확인하고
						입력해주세요
					</div>
					<label for="carNumber" class="f_gray_5 body_9">{{
						isErrorCarNumber ? "차대번호" : "차량번호"
					}}</label>
					<input
						v-if="!isErrorCarNumber"
						id="carNumber"
						placeholder="차량번호 입력"
						class="body_5_M"
						:value="carNumber"
						maxlength="8"
						@input="handleCarNumberChange" />
					<input
						v-if="isErrorCarNumber"
						id="vin"
						placeholder="차대번호(VIN) 입력"
						class="body_5_M"
						:value="vinNo"
						maxlength="17"
						@input="handleVinChange" />
					<div v-if="!isErrorCarNumber" class="search_car_term_wrapper">
						<CheckBox v-for="(item, index) in items" :key="item.title" :text="item.title" :size="14"
							:value="item.isChecked" :typo="'body_11_M'" :onClick="value => handleCheck(value, index)"
							:onLabelClick="() => handleTermModalOpen(index)" />
					</div>
					<div class="vin_info_accodian" v-if="isErrorCarNumber">
						<div :class="`top ${isOpenVin && 'is_open'}`" @click="toggleVin">
							<div>
								<img src="/static/icons/green_fill_checked.svg" />
								<p class="body_8_M" style="lineHeight: 18px">
									차대번호는 보통 이런 곳에 있어요
								</p>
							</div>
							<img src="/static/icons/arrow/arrow_small_bold_right.svg" />
						</div>
						<div class="bottom" v-show="isOpenVin">
							<img src="/static/images/ai/vin.png" width="100%" alt="VIN" />
						</div>
					</div>
				</div>
			</div>
			<BottomFloatButton
				v-show="!isLoading"
				label="조회하기"
				:disabled="!isVerify || !isAllChecked"
				:onClick="handleSearch" />
			<Alert
				:isVisible="isOpenAlert"
				:title="'차대번호를 찾을 수 없어요'"
				:secondaryText="'다시 입력하기'"
				:primaryText="'차종 선택하기'"
				:onClickPrimary="handleAlertClose"
				:onClickSecondary="handleAlertClose"
				:content="`입력하신 번호로 조회가 불가해요.\n동일 오류가 반복되는 경우 직접 차종을 선택해주세요`" />
			<Alert
				:isVisible="isSearchAlert"
				:title="'일일 조회 횟수가 초과 되었어요'"
				:primaryText="'다시 입력하기'"
				:onClickPrimary="handleAlert2Close"
				:content="`일일 조회 가능횟수를 초과하였습니다.\n입력하신 차량번호는 일일 조회횟수를 초과하였습니다.\n내일 조회 가능합니다.`" />
			<Alert
				:isVisible="isDatAlert"
				:title="datAlert.title"
				:primaryText="'돌아가기'"
				:onClickPrimary="handleAlert3Close"/>

			<Modal
				v-if="!!termItem"
				:isVisible="!!termItem"
				:title="termItem.title"
				:onClose="handleTermModalClose"
				:hasPadding="true"
				:content="termItem.content"
				>
			</Modal>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import Header from '../../components/ai/AiHeader.vue'
import BottomFloatButton from '../../components/ai/AiBottomFloatButton.vue'
import Toast from '../../components/ai/AiToast.vue'
import Alert from '../../components/ai/AiAlert.vue'
import CheckBox from '../../components/ai/AiCheckBox.vue'
import Button from '../../components/ai/AiButton.vue'
import Modal from '../../components/ai/AiModal.vue'
import lottie from 'lottie-web'
import AppConfig from '@/config'

export default {
	name: 'AiSearchCar',
	data() {
		return {
			carNumber:'',
			vinNo: '',
			isLoading: false, // 차량 번호로 차량 조회 api 호출 시 로딩
			isLoading2: false, // 로딩이 3초 이상 걸리는 경우 h1 test 변경용
			isVerify: false, // 차량 번호 정규식 verify
			isOpenVin: true,
			isAllChecked: true,
			isOpenAlert: false, // 차대번호 조회 오류 알럿
			isSearchAlert: false, // 차대번호 조회 횟수 초과 알럿
			isDatAlert:false, // DAT 사용불가시 불가 알럿
			isErrorCarNumber: false, // 차량 번호로 차량 vin 조회 실패
			title: `내 차 조회하고\n수리 견적 알아보세요`,
			termItem: undefined,
			items: [],
			datAlert:{
				title:''
			}
		}
	},

	computed:{
		userName(){
			return Vue.$sessionStorage.get('decriptName')
		}
	},

	watch: {
		isErrorCarNumber(newValue) {
			if (newValue) {
				this.title = `차대번호를 다시 입력해주세요`
				this.isLoading = false
				this.isLoading2 = false
			}
		},
		isLoading(newValue) {
			var $this = this;
			var params = {
				carNo:$this.carNumber
			};
			var url = '';
			if($this.isErrorCarNumber){
				// 차량조회 실패시, VIN번호로
			} else {
				if (newValue) {
					this.title = this.userName+`님의\n차량 정보를 검색하고 있어요`
					setTimeout(() => {
						Vue.httpClient
						.post('/m/ai/interface/getVinNo', params)
						.then((response) => {
							if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
								if(response.data.result.vinNo){
									if(response.data.result.cnt == 0 ){
										this.isLoading2 = true;
										this.vinNo = response.data.result.vinNo;
									}else{
										this.isSearchAlert = true;
									}
								} else {
									this.isErrorCarNumber = true
									this.isVerify = false
								}
							}
						})
						.catch(e => {
							this.isErrorCarNumber = true
							this.isVerify = false
						})
					}, 2000)
				}
			}
		},
		isLoading2(newValue) {
			if (newValue) {
				this.title = `거의 다 됐어요!\n조금만 더 기다려주세요`
				setTimeout(() => {
					Vue.$sessionStorage.set('aiVinNo', this.vinNo);
					Vue.$sessionStorage.set('aiCarNo', this.carNumber);
					this.$router.push({ name: 'AiChooseMethod'})
				}, 2000)
			}
		}
	},
	methods: {
		handlePrev() {
			this.$router.push({ name: 'AiMain' })
		},
		handleVinChange(e) {
			this.vinNo = e.target.value
			const { value } = e.target
			const removeBlank = value.replace(/ /g, '')
			this.vinNo = removeBlank
			this.isVerify = !!removeBlank && /^[A-HJ-NPR-Z0-9]{17}$/.test(removeBlank)
		},
		handleCarNumberChange(e) {
			const { value } = e.target
			const removeBlank = value.replace(/ /g, '')
			this.carNumber = removeBlank
			this.isVerify = !!removeBlank && /^([가-힣]{2})?\d{2,3}[가-힣]\s?\d{4}$/.test(removeBlank)
		},
		handleSearch() {
			if (this.isErrorCarNumber) {
				if(this.vinNo){
					var params = {
						vinNo:this.vinNo
					};
					setTimeout(() => {
						Vue.httpClient
						.post('/m/ai/interface/getVinNo', params)
						.then((response) => {
							if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
								if(response.data.result.vinNo){
									if(response.data.result.cnt == 0 ){
										Vue.$sessionStorage.set('aiVinNo', this.vinNo);
										Vue.$sessionStorage.set('aiCarNo', this.carNumber);
										this.$router.push({ name: 'AiChooseMethod'})
									}else{
										this.isSearchAlert = true;
									}
								} else {
									this.isOpenAlert = true;
								}
							}
						})
						.catch(e => {
							this.isOpenAlert = true;
						})
					}, 2000)
				}
			} else {
				this.isLoading = true
			}
		},
		handleTermModalClose() {
			this.termItem = undefined
		},
		handleAlertClose() {
			this.isOpenAlert = false
		},
		handleAlert2Close() {
			this.isSearchAlert = false;
			this.isLoading = false;
			this.title = `내 차 조회하고\n수리 견적 알아보세요`;
		},
		handleAlert3Close() {
			this.$router.push({ name: 'AiMain'})
		},
		handleCheck(value, index) {
			this.items[index].isChecked = value
			this.isAllChecked = this.items.every(({ required, isChecked }) =>
				!required || isChecked === true
			);
		},
		handleTermModalOpen(index) {
			this.termItem = this.items[index]
			this.items[index].isChecked = true
		},
		toggleVin() {
			this.isOpenVin = !this.isOpenVin
		}
	},
	components: {
		Header,
		BottomFloatButton,
		Toast,
		CheckBox,
		Button,
		Alert,
		Modal
	},
	mounted() {
		var $this = this;
		this.animation = lottie.loadAnimation({
			container: this.$refs.lottieContainer,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			path: '../../../static/json/car-loading.json'
		})

		Vue.httpClient
		.post('/m/ai/datCheck')
		.then(response => {
			if(response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS){

				if(response.data.result==='Y'){
						Vue.httpClient
						.post('/m/ai/term/list', {termType:20})
						.then(response => {
							if(response.data.status=='200'){

								var result = response.data.result
								result.forEach((item)=>{
									let pushitem={}
									pushitem.title = item.title
									pushitem.content = item.contents
									pushitem.termSeq = item.termSeq
									if(item.requiredYn==='Y'){
										pushitem.required = true
										pushitem.isChecked = true
									} else {
										pushitem.required = false
										pushitem.isChecked = false
									}
									$this.items.push(pushitem)
								})
							}
						})
					} else {
						throw new Error('시스템 점검중입니다.\n잠시 후 다시 이용해주시기 바랍니다.')
					}
				} else {
					throw new Error('오류가 발생하였습니다.\n잠시 후 다시 이용해주시기 바랍니다.')
				}

		}).catch((e)=>{
			if(e.message){
				this.datAlert.title = e.message
			} else {
				this.datAlert.title = `오류가 발생하였습니다.\n잠시 후 다시 이용해주시기 바랍니다.`
			}
			this.isDatAlert=true;
		})
	},
	beforeDestroy() {
		if (this.animation) {
			this.animation.destroy() // cleanup
		}
	}
}
</script>

<style scoped>
.close_button_wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 12px;
}

.vin_info_accodian {
	margin-top: 32px;
	margin-bottom: 80px;
}

.vin_info_accodian>.top {
	display: flex;
	align-content: center;
	justify-content: space-between;
	padding: 12px 20px;
	background-color: var(--gray-scale-10);
	border-radius: 8px;
}

.search_car_term_wrapper {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 16px;
	flex-wrap: wrap;
}

.is_open {
	border-bottom-left-radius: 0 !important;
	border-bottom-right-radius: 0 !important;
}

.vin_info_accodian>.top>img {
	transform: rotate(-90deg);
}

.vin_info_accodian>.top>div {
	display: flex;
	align-content: center;
	gap: 8px;
}

.vin_info_accodian>.bottom {
	padding: 32px;
	border: 1px solid var(--gray-scale-9);
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/ai/AiSearchCar.vue